import Pages from 'containers/Pages';
import Dash from 'containers/Dash';

const appRoutes = [ 
 
  { component: Pages, path: '*', exact: false, name: 'Pages' },
  { component: Pages, path: '/login', exact: false, name: 'Pages' },
 
  { component: Dash, path: '/src/*', exact: false, name: 'Dash' },
];

export default appRoutes;
